import { render, staticRenderFns } from "./MultipleSelectInnerNormal.vue?vue&type=template&id=2880025c&scoped=true"
import script from "./MultipleSelectInnerNormal.vue?vue&type=script&lang=js"
export * from "./MultipleSelectInnerNormal.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelectInnerNormal.vue?vue&type=style&index=0&id=2880025c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880025c",
  null
  
)

export default component.exports